import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import moment from "moment";
import supplierService from "../Services/supplierService";
import purchaseService from "../Services/purchaseService";
import productService from "../Services/productService";
import Dropdown from "../Components/Dropdown";
import { LoadingDots } from "../Components/LoadingDots";

const CreatePurchaseOrderDirect = () => {
  const [loading, setLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [file, setFile] = useState(null);
  const [reference, setReference] = useState("");
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedSupplier, setSelectedSupplier] = useState("");

  const navigate = useNavigate();

  // Fetch suppliers
  useEffect(() => {
    const fetchSuppliers = async () => {
      setLoading(true);
      try {
        const res = await supplierService.fetchAll();
        setSuppliers(res.suppliers);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchSuppliers();
  }, []);

  // File selection
  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
  };

  // Read Excel file and match products
  const proceedFileRead = () => {
    if (!file) return toast.error("Please upload a file!");

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);

        if (!json.length) return toast.error("Excel is empty!");

        const vendorCodes = json
          .map((item) => item.vendor_code?.toString().trim())
          .filter(Boolean)
          .join(",");

        // const res = await productService.searchByVendor(vendorCodes);
        // const dbProducts = res.products;

        const normalize = (val) =>
          val
            ?.toString()
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "");

        // FIRST SEARCH
        let res = await productService.searchByVendor(vendorCodes);

        let dbProducts = res.products || [];

        console.log("INITIAL DB PRODUCTS:", dbProducts);

        // FIND MISSING PRODUCTS
        const missingExcelProducts = json.filter((item) => {
          const code = item.vendor_code?.toString().trim();

          return !dbProducts.find(
            (p) => normalize(p.vendor_code) === normalize(code),
          );
        });

        console.log("MISSING PRODUCTS:", missingExcelProducts);

        // CREATE MISSING PRODUCTS
        if (missingExcelProducts.length > 0) {
          toast.loading("Creating missing products...");

          await productService.bulkCreateMissing(
            missingExcelProducts.map((item) => ({
              vendor_code: item.vendor_code,
              brand: item.brand,
              title: item.title || item.brand,
              quantity: item.quantity || 0,
              weight: item.weight || 0,
              delivery: item.delivery || "",
              supplier_code: item.supplier_code || "",
              supplier:
                suppliers.find(
                  (s) => normalize(s.company) === normalize(item.supplier),
                )?.id || selectedSupplier,
              price: item.price || item.order_price || 0,
              order_price: item.order_price || item.price || 0,
              reference,
            })),
          );

          toast.dismiss();

          toast.success(
            `${missingExcelProducts.length} missing products created`,
          );

          // SEARCH AGAIN AFTER INSERT
          res = await productService.searchByVendor(vendorCodes);

          dbProducts = res.products || [];

          console.log("UPDATED DB PRODUCTS:", dbProducts);
        }

        // const finalProducts = json
        //   .map((item) => {
        //     const code = item.vendor_code?.toString().trim();
        //     const found = dbProducts.find(
        //       (p) => p.vendor_code?.toString().trim() === code
        //     );
        //     if (!found) return null;
        //     return {
        //       product: found.id,
        //       vendor_code: found.vendor_code,
        //       brand: found.brand,
        //       quantity: parseFloat(item.quantity),
        //       weight: parseFloat(found.weight || 0),
        //       delivery: found.delivery,
        //       order_price: parseFloat(
        //         item.order_price || found.order_price || found.price || 0
        //       ),
        //       supplier: found.supplier,
        //       availability: "FULFILLED",
        //     };
        //   })
        //   .filter(Boolean);

        // const finalProducts = json
        //   .map((item) => {
        //     const code = item.vendor_code?.toString().trim();
        //     console.log("Excel Supplier:", item.supplier);

        //     console.log(
        //       "Matched Supplier:",
        //       suppliers.find((s) => {
        //         const db = s.company?.toString().toLowerCase().trim();
        //         const ex = item.supplier?.toString().toLowerCase().trim();
        //         return db === ex;
        //       }),
        //     );
        //     if (!code) return null;

        //     const found = dbProducts.find(
        //       (p) => normalize(p.vendor_code) === normalize(code),
        //     );

        //     if (!found) return null;

        //     // ✅ FIX SUPPLIER (PRIORITY ORDER)
        //     const supplierId =
        //       found.supplier ||
        //       // ✅ Case 1: Excel gives supplier ID (number)
        //       (typeof item.supplier === "number" ? item.supplier : null) ||
        //       // ✅ Case 2: Excel gives supplier NAME
        //       suppliers.find(
        //         (s) => normalize(s.company) === normalize(item.supplier),
        //       )?.id ||
        //       // ✅ fallback
        //       selectedSupplier ||
        //       null;

        //     const excelWeight = Number(item?.weight);
        //     const dbWeight = Number(found?.weight);

        //     const finalWeight =
        //       Number.isFinite(excelWeight) && excelWeight > 0
        //         ? excelWeight
        //         : Number.isFinite(dbWeight) && dbWeight > 0
        //           ? dbWeight
        //           : 0;

        //     return {
        //       product: found.id,
        //       vendor_code: found.vendor_code,
        //       brand: found.brand || item.brand,

        //       quantity: parseFloat(item.quantity) || 0,
        //       //weight: parseFloat(found.weight || item.weight || 0),
        //       weight: finalWeight,

        //       delivery: found.delivery || item.delivery,

        //       // ✅ FIX PRICE
        //       order_price: parseFloat(
        //         item.price || item.order_price || found.price || 0,
        //       ),

        //       supplier: supplierId,
        //       availability: "FULFILLED",
        //     };
        //   })
        //   .filter(Boolean);

        console.log("====================================");
        console.log("SEARCHING PRODUCTS FROM API");
        console.log("API:", "productService.searchByVendor(vendorCodes)");
        console.log("Vendor Codes Sent:", vendorCodes);
        console.log("====================================");

        console.log("Products Returned From DB/API:");
        console.log(dbProducts);

        const missingProducts = [];
        const matchedProducts = [];

        const finalProducts = json
          .map((item, index) => {
            const code = item.vendor_code?.toString().trim();

            console.log(`\n========== EXCEL ROW ${index + 1} ==========`);

            console.log("Excel Product:", item);

            if (!code) {
              console.log("❌ Missing vendor_code in Excel row");
              missingProducts.push({
                row: index + 1,
                reason: "Missing vendor_code",
                item,
              });
              return null;
            }

            console.log("Searching Vendor Code:", code);

            const found = dbProducts.find(
              (p) => normalize(p.vendor_code) === normalize(code),
            );

            if (!found) {
              console.log("❌ PRODUCT NOT FOUND IN DATABASE");
              console.log("Excel Vendor Code:", code);

              missingProducts.push({
                row: index + 1,
                vendor_code: code,
                reason: "No matching product in DB",
                excelProduct: item,
              });

              return null;
            }

            console.log("✅ PRODUCT MATCHED");
            console.log("Matched DB Product:", found);

            matchedProducts.push({
              excel_vendor_code: code,
              db_vendor_code: found.vendor_code,
              product_id: found.id,
            });

            // SUPPLIER
            const supplierId =
              found.supplier ||
              (typeof item.supplier === "number" ? item.supplier : null) ||
              suppliers.find(
                (s) => normalize(s.company) === normalize(item.supplier),
              )?.id ||
              selectedSupplier ||
              null;

            // WEIGHT
            const excelWeight = Number(item?.weight);
            const dbWeight = Number(found?.weight);

            const finalWeight =
              Number.isFinite(excelWeight) && excelWeight > 0
                ? excelWeight
                : Number.isFinite(dbWeight) && dbWeight > 0
                  ? dbWeight
                  : 0;

            return {
              product: found.id,
              vendor_code: found.vendor_code,
              brand: found.brand || item.brand,

              quantity: parseFloat(item.quantity) || 0,

              weight: finalWeight,

              delivery: found.delivery || item.delivery,

              order_price: parseFloat(
                item.price || item.order_price || found.price || 0,
              ),

              supplier: supplierId,

              availability: "FULFILLED",
            };
          })
          .filter(Boolean);

        console.log("\n====================================");
        console.log("MATCHED PRODUCTS");
        console.log(matchedProducts);

        console.log("\n====================================");
        console.log("MISSING PRODUCTS");
        console.log(missingProducts);

        console.log("\n====================================");
        console.log("FINAL PRODUCTS TO SUBMIT");
        console.log(finalProducts);

        if (missingProducts.length > 0) {
          console.warn(
            `⚠️ ${missingProducts.length} products were missing from database`,
          );

          toast.error(
            `${missingProducts.length} products not found in database`,
          );
        }

        if (!finalProducts.length)
          return toast.error("No matching products found!");
        setProducts(finalProducts);
        toast.success("Products loaded successfully!");
      } catch (err) {
        console.error(err);
        toast.error("Error processing file!");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // Delete product from table
  const handleDelete = (index) => {
    setProducts((prev) => prev.filter((_, i) => i !== index));
  };

  // Submit purchase orders
  const handlePurchaseCreate = async () => {
    if (!products.length) return toast.error("No products to submit!");
    if (!selectedSupplier) return toast.error("Please select a supplier!");

    const grouped = {};
    for (const p of products) {
      const supplierId = p.supplier || selectedSupplier;
      if (!grouped[supplierId]) {
        grouped[supplierId] = {
          supplier: supplierId,
          products: [],
          amount: 0,
          paid_amount: 0,
          payment_status: "UNPAID",
          purchase_date: date,
          reference,
        };
      }
      grouped[supplierId].products.push(p);
      grouped[supplierId].amount += p.order_price * p.quantity;
    }

    try {
      setLoading(true);
      for (const key in grouped) {
        await purchaseService.submitPurchase(grouped[key]);
      }
      toast.success("Purchase Orders Created!");
      navigate("/purchase");
    } catch (err) {
      console.error(err);
      toast.error("Failed to create purchase order!");
    }
    setLoading(false);
  };

  return (
    <div className="mx-16 my-10">
      <div className="bg-accent rounded-xl py-6 px-10 flex flex-col gap-6">
        {/* Supplier, Reference, Date */}
        <div className="flex flex-row gap-4 mb-4 w-full">
          {/* Supplier Dropdown */}
          <div className="flex flex-col w-1/3">
            <label className="primary-label block mb-1 font-bold">
              Supplier
            </label>
            <Dropdown
              style="!col-span-2 w-full"
              selected={selectedSupplier}
              placeholder="Select Supplier"
              onChange={(value) => setSelectedSupplier(value)}
              options={suppliers.map((supplier) => ({
                label: supplier.company,
                value: supplier.id,
              }))}
            />
          </div>

          <div className="flex flex-col w-1/3">
            <label className="primary-label block mb-1 font-bold">
              Reference
            </label>
            <input
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              placeholder="Enter Reference"
              className="w-full py-2 text-sm px-4 bg-gray-100 rounded-lg focus:outline-none border border-gray-100 focus:border-gray-300"
            />
          </div>

          <div className="flex flex-col w-1/3">
            <label className="primary-label block mb-1 font-bold">Date</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="w-full py-2 text-sm px-4 bg-gray-100 rounded-lg focus:outline-none border border-gray-100 focus:border-gray-300"
            />
          </div>
        </div>

        {/* File Upload */}
        <div className="w-full flex flex-row items-center justify-center mb-3 mt-10 gap-3">
          <input
            type="file"
            onChange={handleFileSelect}
            className="w-72 py-1 text-md px-4 bg-gray-100 rounded-full focus:outline-none border border-gray-100 focus:border-gray-300
            file:mr-4 file:py-[7px] file:px-6 file:rounded-full
             file:border-0 file:text-sm file:font-semibold
             file:bg-white file:text-black
              hover:file:bg-primary hover:file:text-white"
          />
          <button
            onClick={proceedFileRead}
            className="bg-primary px-2 w-32 py-1 rounded-full text-white font-semibold text-lg"
          >
            Proceed
          </button>
        </div>

        {/* Product Table */}
        {products.length > 0 && (
          <div className="overflow-x-auto mt-6 rounded-xl border border-gray-200">
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="bg-primary text-white text-xs uppercase">
                  <th className="py-2 px-3">Supplier</th>
                  <th className="py-2 px-3">Brand</th>
                  <th className="py-2 px-3">Part No.</th>
                  <th className="py-2 px-3">Quantity</th>
                  <th className="py-2 px-3">Weight</th>
                  <th className="py-2 px-3">Total Weight</th>
                  <th className="py-2 px-3">Item Price</th>
                  <th className="py-2 px-3">Total Price</th>
                </tr>
              </thead>
              <tbody>
                {products.map((p, idx) => (
                  <tr
                    key={idx}
                    className="text-center border-b border-gray-200 bg-gray-100"
                  >
                    <td className="py-2 px-2 font-semibold">
                      {suppliers.find((s) => s.id === p.supplier)?.company ||
                        "N/A"}
                    </td>
                    <td className="py-2 px-2">{p.brand}</td>
                    <td className="py-2 px-2">{p.vendor_code}</td>
                    <td className="py-2 px-2">{p.quantity}</td>
                    <td className="py-2 px-2">
                      {parseFloat(p.weight).toFixed(2)}
                    </td>
                    <td className="py-2 px-2">
                      {(p.quantity * p.weight).toFixed(2)}
                    </td>
                    <td className="py-2 px-2">
                      {parseFloat(p.order_price).toFixed(2)}
                    </td>
                    <td className="py-2 px-2">
                      {(p.order_price * p.quantity).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-primary text-white font-semibold text-center">
                  <td className="py-2 px-2 text-left" colSpan={3}>
                    Total
                  </td>
                  <td className="py-2 px-2">
                    {products
                      .reduce(
                        (sum, p) => sum + (parseFloat(p.quantity) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td className="py-2 px-2"></td>
                  <td className="py-2 px-2">
                    {products
                      .reduce(
                        (sum, p) =>
                          sum +
                          (parseFloat(p.quantity) || 0) *
                            (parseFloat(p.weight) || 0),
                        0,
                      )
                      .toFixed(2)}
                  </td>
                  <td className="py-2 px-2"></td>
                  <td className="py-2 px-2">
                    {products
                      .reduce(
                        (sum, p) =>
                          sum +
                          (parseFloat(p.order_price) || 0) *
                            (parseFloat(p.quantity) || 0),
                        0,
                      )
                      .toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        {/* Create Purchase Button */}
        <div className="flex justify-center mt-6">
          <button
            onClick={handlePurchaseCreate}
            className="bg-primary px-4 w-54 py-1 rounded-full hover:bg-primary/80 text-white font-medium text-lg"
          >
            {loading ? <LoadingDots /> : "Create Purchase Order"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePurchaseOrderDirect;
